import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NotificationService } from 'app/api/sidc-services/employee-portal/main';
import { environment } from 'environments/environment';
import { takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private avatarPath:string = environment.avatarPath;
  // Public
  public apiData = [];
  public onApiDataChange: BehaviorSubject<any>;
  private unsubscribeAll: Subject<any>;

  /**
   *
   * @param {HttpClient} _httpClient
   */
  constructor(private _httpClient: HttpClient,
    private notificationService: NotificationService,
  ) {
    this.onApiDataChange = new BehaviorSubject('');
     //this.getNotificationsData();
    this.setPage();
  }

  /**
   * Get Notifications Data
   */
  getNotificationsData(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this._httpClient.get('api/notifications-data').subscribe((response: any) => {
        this.apiData = response;
        this.onApiDataChange.next(this.apiData);
        resolve(this.apiData);
      }, reject);
    });
  }

  setPage() {
    //this.blockUI.start();
    //this.notificationService.apiVversionNotificationGetByEmployeeCodeGet(environment.apiVersion).pipe(takeUntil(this.unsubscribeAll)).subscribe(response => {
    this.notificationService.apiVversionNotificationGetByEmployeeCodeGet(environment.apiVersion).subscribe(response => {
    console.log("notiffff",response);
    this.apiData =  response;
    }, (httpError: HttpErrorResponse) => {
      //this.blockUI.stop();
      
    });
  }

  
}
